import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaStamp } from "react-icons/fa6";
import FinalPays from "./index";
import ViewFinalPay from "./view";
import EditFinalPay from "./edit";
import { MODULE_FINAL_PAYS } from "variables/constants";

const finalPayRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Final Pays",
		basePath: "final-pays",
		mainComponent: <FinalPays />,
		layout: "/console",	   
		icon: <FaStamp className="icon-item" />,
		subTitle:"Final Pay",
		viewComponent: <ViewFinalPay />,
		createComponent: <EditFinalPay />,
		editComponent: <EditFinalPay />,
		level:3,
		moduleId: MODULE_FINAL_PAYS,
	})
]

export default finalPayRoutes;